const TableCellTextFormatter = ({ value, mask, idField }) => {	
	const fieldElement = $("#"+idField);
	let valueFormated = value;

	if (mask && fieldElement.length) {
		valueFormated = fieldElement.masked(value);
	}

	const validateValue = valueFormated.indexOf && valueFormated.indexOf(" ") >= 0;
	const classValueFormated = valueFormated.length > 200 ? "long-text" : "";
	const classValidateValue = !validateValue ? " formattingValue" : "";

	return (
		<span
			className={`${classValueFormated + classValidateValue} table-cell__content`}
			style={{whiteSpace: 'pre-line'}}
			tabIndex="0"
		>
			{valueFormated}
		</span>
	);
};

export default TableCellTextFormatter;
